
const getEmails = (sent, total) => {
  return total.map((totalElem) => {
    totalElem.isSent = sent.some((sentElem) => sentElem.email === totalElem.email)
    totalElem.isVisible = true
    return totalElem
  })
}

const getCreatedAt = (data) => {
  const { sent, total } = data

  if (sent.length === 0 && total.length > 0) {
    return {
      hasDate: false,
      createdAt: 'Unsent emails'
    }
  }
  if (sent.length > 0) {
    return {
      hasDate: true,
      createdAt: sent[0].createdAt
    }
  }
  return {
    createdAt: null,
    hasDate: false
  }
}

const getStatus = (data) => {
  const { sent, total } = data
  return `${sent.length}/${total.length} emails`
}

export default (data) => ({
  ...getCreatedAt(data),
  status: getStatus(data),
  emails: getEmails(data.sent, data.total)
})



// WEBPACK FOOTER //
// ./src/api/campaigns/EmailsModel.js